<template>
    <Card>
        <div class="card-body">
            <router-link :to="{ name: 'OrderPaymentCreatePage'}" class="btn btn-link legitRipple">
                <i class="icon-plus3 mr-2"></i>{{ $t('buttons.add') }}
            </router-link>
        </div>
        <FetchTable
            :handle="tableHandle"
            :url="url"
            :columns="columns"
            v-model:orders="orders"
        >
            <template #td-id="{ row }">
                <router-link :to="{ name: 'OrderPaymentEditPage', params: { orderPaymentUuid: row.uuid } }">
                    {{ row.id }}
                </router-link>
            </template>
            <template #td-sum="{ row }">
                {{ Price.factory(row.sum).toCurrencyString('UAH') }}
            </template>
            <template #td-type="{ row }">
                {{ $t(`enums.OrderPaymentTypeEnum.${row.type}`) }}
            </template>
            <template #td-is_paid="{ row }">
                {{ row.is_paid ? $t('labels.paid') : $t('labels.not_paid') }}
            </template>
            <template #td-created_at="{ row }">
                {{ DateFormatter.formatDateTime(row.created_at) }}
            </template>
            <template #td-updated_at="{ row }">
                {{ DateFormatter.formatDateTime(row.updated_at) }}
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import FetchTable from "../../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../../components/new/table/tableHandle";

import DateFormatter from "../../../../../services/DateFormatter";
import Price from "../../../../../services/Price/Price";

export default {
    name: "OrderPaymentsPage",
    components: {
        Card, FetchTable
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            Price,
            DateFormatter,
            url: `/projects/${this.$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}/payments`,
            orders: [
                { column: 'created_at', dir: 'asc' }
            ],
            columns: [
                { key: 'id', name: this.$t('table.titles.id'), width: '80px', type: 'string', order: true },
                { key: 'type', name: this.$t('labels.type'), width: '200px', type: 'string', order: false },
                { key: 'comment', name: this.$t('labels.comment'), width: 'auto', type: 'string', order: false },
                { key: 'sum', name: this.$t('labels.sum'), width: '200px', type: 'string', order: false },
                { key: 'is_paid', name: this.$t('labels.status'), width: '200px', type: 'string', order: false },
                { key: 'created_at', name: this.$t('table.titles.created_at'), width: '200px', type: 'string', order: true },
                { key: 'updated_at', name: this.$t('table.titles.updated_at'), width: '200px', type: 'string', order: true },
            ]
        }
    },
    mounted() {
        this.tableHandle.fetchRows()
    }
}
</script>